import type { SVGProps } from 'react';

const SvgArrowSmallW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17 11.002H9.41l1.29-1.29a.996.996 0 1 0-1.41-1.41l-3 3a.996.996 0 0 0 0 1.41l3 3c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29h7.59c.55 0 1-.45 1-1s-.45-1-1-1z"
    />
  </svg>
);
export default SvgArrowSmallW;
